import type { FC } from 'react';
import { AdsHistoryTT } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';
import { Guard, usePermissionGuard } from 'features/login';

const AdsHistoryPage: FC = () => {
  const { accessToViewAdlog } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToViewAdlog} fallback>
      <CabinetTitlePage title={'Ads History'} />
      <AdsHistoryTT />
    </Guard>
  );
};

export default AdsHistoryPage;
